<template>
	<v-container class="py-16">
		<v-card
			class="overflow-hidden"
			flat
			rounded="xl"
			:img="require('@/assets/landing/brooke-cagle-JBwcenOuRCg-unsplash.jpg')"
		>
			<v-container class="pa-16 white--text">
				<v-row class="mb-16">
					<v-col class="mb-16" cols="12" md="6" lg="4">
						<div class="font-weight-bold mb-16 text-h5">Looking for a job?</div>

						<div class="font-weight-bold mb-6 text-h3">
							Find the career you always wished
						</div>

						<div class="mb-16 text-h6">
							With our extensive database of job openings across the country,
							you're sure to find the perfect opportunity. Start searching today
							and take the first step towards your career goals!
						</div>
					</v-col>
				</v-row>

				<v-row class="align-stretch justify-space-between mt-16">
					<v-col cols="12" md="6" lg="4">
						<v-card
							to="/search?q=retail&nbsp;salesperson"
							class="d-flex flex-column align-start pa-6 rounded-lg"
							color="blue lighten-5"
							height="100%"
						>
							<div class="font-weight-bold mb-3 text-h5">
								Retail salesperson
							</div>

							<div class="mb-6 text-body-2">
								Looking for a job in retail? We've got you covered! Browse our
								curated list of job openings specifically for retail salespeople
								and start your career today.
							</div>

							<v-btn class="mt-auto" outlined>
								View jobs
								<v-icon right dark> mdi-arrow-right-thin </v-icon>
							</v-btn>
						</v-card>
					</v-col>

					<v-col cols="12" md="6" lg="4">
						<v-card
							to="/search?q=cashier"
							class="d-flex flex-column align-start pa-6 rounded-lg"
							color="blue lighten-5"
							height="100%"
						>
							<div class="font-weight-bold mb-3 text-h5">Cashier</div>

							<div class="mb-6 text-body-2">
								Are you a whiz with numbers and enjoy working with people? Check
								out our selection of job openings specifically for cashier
								positions and find your next opportunity.
							</div>

							<v-btn class="mt-auto" outlined>
								View jobs
								<v-icon right dark> mdi-arrow-right-thin </v-icon>
							</v-btn>
						</v-card>
					</v-col>

					<v-col cols="12" md="6" lg="4">
						<v-card
							to="/search?q=food&nbsp;service"
							class="d-flex flex-column align-start pa-6 rounded-lg"
							color="blue lighten-5"
							height="100%"
						>
							<div class="font-weight-bold mb-3 text-h5">Food service</div>

							<div class="mb-6 text-body-2">
								Passionate about the food service industry? Look no further! Our
								filtered list of job openings tailored specifically for food
								service workers has got you covered.
							</div>

							<v-btn class="mt-auto" outlined>
								View jobs
								<v-icon right dark> mdi-arrow-right-thin </v-icon>
							</v-btn>
						</v-card>
					</v-col>

					<v-col cols="12" md="6" lg="4">
						<v-card
							to="/search?q=customer&nbsp;service"
							class="d-flex flex-column align-start pa-6 rounded-lg"
							color="blue lighten-5"
							height="100%"
						>
							<div class="font-weight-bold mb-3 text-h5">Customer service</div>

							<div class="mb-6 text-body-2">
								Enjoy working with people and solving problems? Search our
								selection of job openings tailored specifically for customer
								service representative positions and find your next career move.
							</div>

							<v-btn class="mt-auto" outlined>
								View jobs
								<v-icon right dark> mdi-arrow-right-thin </v-icon>
							</v-btn>
						</v-card>
					</v-col>

					<v-col cols="12" md="6" lg="4">
						<v-card
							to="/search?q=security&nbsp;guard"
							class="d-flex flex-column align-start pa-6 rounded-lg"
							color="blue lighten-5"
							height="100%"
						>
							<div class="font-weight-bold mb-3 text-h5">Security guard</div>

							<div class="mb-6 text-body-2">
								Looking for a career in security? Browse our curated list of job
								openings specifically for security guard positions and start
								your career today.
							</div>

							<v-btn class="mt-auto" outlined>
								View jobs
								<v-icon right dark> mdi-arrow-right-thin </v-icon>
							</v-btn>
						</v-card>
					</v-col>

					<v-col cols="12" md="6" lg="4">
						<v-card
							to="/search?q=truck&nbsp;driver"
							class="d-flex flex-column align-start pa-6 rounded-lg"
							color="blue lighten-5"
							height="100%"
						>
							<div class="font-weight-bold mb-3 text-h5">Truck driver</div>

							<div class="mb-6 text-body-2">
								Need a job on the open road? Explore our selection of job
								openings tailored specifically for truck drivers and find your
								next opportunity to drive towards success.
							</div>

							<v-btn class="mt-auto" outlined>
								View jobs
								<v-icon right dark> mdi-arrow-right-thin </v-icon>
							</v-btn>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'CategoryCards',
	data: () => ({
		//
	}),
};
</script>
